import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

export function LogoutPage() {
  useEffect(() => {
    delete window.localStorage.token;
  }, []);
  return <Navigate to={"/auth/login"} />;
}
